import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

function formatParams(ctx, params, add) {
    const getParams = {
        user_id: ctx.rootState.userId,
        auth_key: ctx.rootState.authToken,
        sort_by: params.sort_by,
        sort_type: params.sort_type,
        page: params.page,
        ...(add || {})
    };

    const postParams = {
        filters: params.filters,
        col_filters: params.columnFilters
    };

    const search = Object.entries(getParams)
        .map(([key, value]) => `${key}=${value}`)
        .join("&");

    return { getParams, postParams, search };
}

export default {
    namespaced: true,

    actions: {
        async loadFilters(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/filters&user_id=${userId}`, token)
            );

            const json = await res.json();

            return json;
        },

        async loadColumns(ctx) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/columns&user_id=${userId}`, token)
            );

            const json = await res.json();

            return json;
        },

        async loadUserColumns(ctx) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/user-columns&user_id=${userId}`, token)
            );

            const json = await res.json();

            return json.columns;
        },

        async saveUserColumns(ctx, params) {
            const token = ctx.rootState.authToken;
            const {userId} = ctx.rootState;

            const fd = serialize({
                columns: JSON.stringify(params.columns),
                user_id: userId
            });

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/save-user-columns&user_id=${userId}`, token),
                {
                    method: "POST",
                    body: fd
                }
            );

            const json = await res.json();

            return json;
        },

        async loadWorkers(ctx, params) {
            const token = ctx.rootState.authToken;
            const { search, postParams } = formatParams(ctx, params, {
                r: "api/reports/workers-debt-balance"
            });

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token), {
                method: "POST",
                body: serialize(postParams)
            });

            const json = await res.json();

            return json;
        },

        async loadChartDataByFilials(ctx, params) {
            const token = ctx.rootState.authToken;
            const { search, postParams } = formatParams(ctx, params, {
                r: "api/reports/workers-debt-balance/by-filial"
            });

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token), {
                method: "POST",
                body: serialize(postParams)
            });

            const json = await res.json();

            return json;
        },

        async loadChartDataByPositions(ctx, params) {
            const token = ctx.rootState.authToken;
            const { search, postParams } = formatParams(ctx, params, {
                r: "api/reports/workers-debt-balance/by-post"
            });

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token), {
                method: "POST",
                body: serialize(postParams)
            });

            const json = await res.json();

            return json;
        },

        async getReferenceValues(ctx, columnId) {
            const token = ctx.rootState.authToken;

            const res = await fetch(addAuthKey(`${api_url}/?r=api/reports/workers-debt-balance/filter-data&filter_column=${columnId}`, token));

            const json = await res.json();

            return json;
        },

        async toGoogleSpreadsheet(ctx, params) {
            const token = ctx.rootState.authToken;
            const { search, postParams } = formatParams(ctx, params, {
                r: "api/reports/workers-debt-balance/export-google-sheets"
            });

            const res = await fetch(addAuthKey(`${api_url}/?${search}`, token), {
                method: "POST",
                body: serialize(postParams)
            });

            const json = await res.json();

            return json;
        },

    }
};
